import { Firestore } from '@angular/fire/firestore';
import { Storage } from '@angular/fire/storage';
import { Database } from '@angular/fire/database';
import { Progress } from './migration-types';
import { migrateImages } from './1-image-migration';
import { migrateServiceUpdates } from './2-service-update-migration';
import { migrateToFirestore } from './3-firestore-migration';

/**
 * Migration step configuration
 */
export interface MigrationStep {
  /** Unique identifier for this migration phase (used for tracking completion) */
  id: string;

  /** Display name for the migration step */
  name: string;

  /** Migration function that yields progress updates */
  migrate: (
    uid: string,
    db: Database,
    firestore: Firestore,
    storage: Storage,
  ) => AsyncGenerator<Progress, void, unknown>;
}

/**
 * All migration steps in chronological order
 *
 * IMPORTANT: The order matters! Do not reorder without understanding the dependencies:
 * 1. Image migration runs first (converts deprecated 'image' field)
 * 2. Service update migration runs second (links orphaned service updates)
 * 3. Firestore migration runs last (migrates all data from RTDB to Firestore)
 */
export const MIGRATION_STEPS: MigrationStep[] = [
  {
    id: '1-images',
    name: 'Migrating images',
    migrate: async function* (uid, db, firestore, storage) {
      yield* migrateImages(uid, db, firestore, storage);
    },
  },
  {
    id: '2-serviceUpdates',
    name: 'Migrating service updates',
    migrate: async function* (uid, db, firestore) {
      yield* migrateServiceUpdates(uid, db, firestore);
    },
  },
  {
    id: '3-firestore',
    name: 'Upgrading database',
    migrate: async function* (uid, db, firestore) {
      yield* migrateToFirestore(uid, db, firestore);
    },
  },
];
